import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getQuestionsForQuestionnaire } from '../services/questionService';
import { Box, Typography, TextField, RadioGroup, FormControlLabel, Radio, Slider, Button } from '@mui/material';


import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const Item = styled(Paper)(({ theme }) => ({
    // Scheme-aware statt fester Hell-/Dunkelwerte
    backgroundColor: theme.palette.background.paper,
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  }));

const AnswerPage = () => {
  const { id: questionnaireId } = useParams();
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const data = await getQuestionsForQuestionnaire(questionnaireId);
        setQuestions(data);
      } catch (error) {
        console.error("Failed to fetch questions:", error);
      }
    };
    
    fetchQuestions();
  }, [questionnaireId]);

  // Handler zum Speichern der Antworten
  const handleAnswerChange = (questionId, value) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: value,
    }));
  };

  const handleSubmit = () => {
    console.log("Submitted Answers:", answers);
    // API-Aufruf zum Speichern der Antworten folgt im nächsten Schritt
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Fragebogen: 
      </Typography>
      <Grid container spacing={2}>
      

      {questions.map((question) => (
        <Grid size={12}>
        <Box key={question.id} sx={{ mb: 3 }}>
        <Item>
          <Typography variant="h6">{question.id}. {question.text}</Typography>
          {question.type === 'MC' && (
            <RadioGroup
              onChange={(e) => handleAnswerChange(question.id, e.target.value)}
            >
              {question.options.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={option}
                  control={<Radio />}
                  label={option}
                />
              ))}
            </RadioGroup>
          )}
          {question.type === 'YN' && (
            <RadioGroup
              onChange={(e) => handleAnswerChange(question.id, e.target.value)}
            >
              <FormControlLabel value="Yes" control={<Radio />} label="Ja" />
              <FormControlLabel value="No" control={<Radio />} label="Nein" />
            </RadioGroup>
          )}
          {question.type === 'TXT' && (
            <TextField
              fullWidth
              variant="outlined"
              onChange={(e) => handleAnswerChange(question.id, e.target.value)}
            />
          )}
          {question.type === 'SLD' && (
            <Slider
              defaultValue={50}
              min={1}
              max={100}
              onChange={(e, value) => handleAnswerChange(question.id, value)}
              valueLabelDisplay="auto"
            />
          )}
         </Item>
        </Box>
        </Grid>
      ))}
        </Grid>

      <Button variant="contained" color="primary" onClick={handleSubmit}>
        Antworten abschicken
      </Button>
    </Box>
  );
};

export default AnswerPage;
